import { observable, computed, action } from "mobx";
import { mapGetOrCreate } from "../utils/mapGetOrCreate";
import { CodeBehaviorsObservedCompact, CodeBehaviorsObserved } from "./CodeBehavior";
import { getRegisteredDomain, urlToDomain } from "../utils/domains";
import { CodeBehaviorsObservedCompactUpdateRecords } from "./CodeBehaviorsRecorder";
import { OptionallyObservableMap } from "../../State/EvidenceDB/DatabaseTypes";

const expandCompactBehaviorsForPageAndCode = (byPageAndCode: OptionallyObservableMap<string, OptionallyObservableMap<string, CodeBehaviorsObservedCompact>>) => 
	new Map([...byPageAndCode.entries()].map(([page, code]) => ([
		page,
		new Map([...code.entries()].map( ([code, codeBehaviorsObservedCompact]) => ([
			code,
			CodeBehaviorsObserved(codeBehaviorsObservedCompact)
		])))
	])));

export class CodeBehaviorsObserver {
	protected _ByPageUrlAndCodeUrl = observable.map<string, OptionallyObservableMap<string, CodeBehaviorsObservedCompact>>();
	protected _ByPageDomainAndCodeUrl = observable.map<string, OptionallyObservableMap<string, CodeBehaviorsObservedCompact>>();
	protected _byPageRegisteredDomainAndCodeRegisteredDomain = observable.map<string, OptionallyObservableMap<string, CodeBehaviorsObservedCompact>>();

	@computed get byPageUrlAndCodeUrl() {
		return expandCompactBehaviorsForPageAndCode(this._ByPageUrlAndCodeUrl);
	}

	@computed get byPageDomainAndCodeUrl() {
		return expandCompactBehaviorsForPageAndCode(this._ByPageDomainAndCodeUrl);
	}

	@computed get byPageRegisteredDomainAndCodeRegisteredDomain() {
		return expandCompactBehaviorsForPageAndCode(this._byPageRegisteredDomainAndCodeRegisteredDomain);
	}

	constructor(updates?: CodeBehaviorsObservedCompactUpdateRecords) {
		if (updates != null) {
			this.integrateUpdates(updates);
		}
	}

	integrateUpdates = action((updates: CodeBehaviorsObservedCompactUpdateRecords) => {
		for (const {pageUrl, byCodeUrl} of updates) {
//			const pageRegisteredDomain = getRegisteredDomain(pageUrl);
			const pageDomain = urlToDomain(pageUrl);
			if (pageDomain == null) continue;
			const pageRegisteredDomain = getRegisteredDomain(pageDomain);
			if (pageRegisteredDomain == null) continue;
			const forPageUrl = mapGetOrCreate(this._ByPageUrlAndCodeUrl, pageUrl, () => observable.map<string, CodeBehaviorsObservedCompact>());			
			const forPageDomainForCodeUrl = mapGetOrCreate(this._ByPageDomainAndCodeUrl, pageDomain, () => observable.map<string, CodeBehaviorsObservedCompact>());
			const forPageRegisteredDomainForCodeRegisteredDomain = mapGetOrCreate(this._byPageRegisteredDomainAndCodeRegisteredDomain, pageRegisteredDomain, () => observable.map<string, CodeBehaviorsObservedCompact>());
			for (const {codeUrl, codeBehaviorsObservedCompact} of byCodeUrl) {
				const codeRegisteredDomain = getRegisteredDomain(codeUrl);
				if (codeRegisteredDomain == null) continue;
				const forPageUrlAndCodeUrl = mapGetOrCreate(forPageUrl, codeUrl, () => observable({} as CodeBehaviorsObservedCompact));
				const forPageDomainAndCodeUrl = mapGetOrCreate(forPageDomainForCodeUrl, codeUrl, () => observable({} as CodeBehaviorsObservedCompact));
				const forCodeRegisteredDomain = mapGetOrCreate(forPageRegisteredDomainForCodeRegisteredDomain, codeRegisteredDomain, () => observable({} as CodeBehaviorsObservedCompact));
				for (const [key, value] of Object.entries(codeBehaviorsObservedCompact)) {
					(forPageUrlAndCodeUrl as { [key: string]: typeof value; })[key] = value;
					(forPageDomainAndCodeUrl as { [key: string]: typeof value; })[key] = value;
					(forCodeRegisteredDomain as { [key: string]: typeof value; })[key] = value;
				}
			}
		}
	});
}
